import { theme } from '@dasa-health/alma-react'

export default theme
